import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=0f83b5e8&"
import script from "./ModalCard.vue?vue&type=script&lang=js&"
export * from "./ModalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalCard.vue"
export default component.exports